import { useMutation } from '@tanstack/react-query';
import { GET, GET_PDPA_DATA } from '../../../services';

export const useGetPdpaData = ({ onSuccess } = {}) => {
  return useMutation({
    mutationFn: async () => {
      const response = await GET(GET_PDPA_DATA());
      return response.result;
    },
    onSuccess: (result) => {
      onSuccess?.(result);
    },
  });
};
